import React, { useMemo } from 'react';

import { useReactNativeProps } from '@eika-infrastruktur/mobilbank-lib';

import { useConfig } from '../../../defaultConfig';
import { usePushDevice } from '../../../fetchHooks/usePushDevice';
import useTranslation from '../../../hooks/useTranslation';
import { pushTrackIDs } from '../../../utils/gtm/trackIDs/push';
import useTogglePushDevice from '../hooks/useTogglePushDevice';
import NotificationMessage from './NotificationMessage';
import NotificationRules from './NotificationRules';
import { ToggleItem } from './ToggleItem';

const NotificationSwitches: React.FC = () => {
    const translated = useTranslation();
    const { featureToggles } = useConfig();
    const { pushEnabledOS } = useReactNativeProps();
    const pushDevice = usePushDevice(!!pushEnabledOS);
    const { onToggle, nativeError, createPushDeviceError, deletePushDeviceError, isPending } = useTogglePushDevice();

    const errorMessage = useMemo(() => {
        if (!!createPushDeviceError || nativeError) return translated.pushNotifications.error;
        if (deletePushDeviceError) return translated.pushNotifications.errorDeactivate;

        return undefined;
    }, [
        translated.pushNotifications.errorDeactivate,
        translated.pushNotifications.error,
        createPushDeviceError,
        nativeError,
        deletePushDeviceError,
    ]);

    return (
        <section className="notifications-settings__switches">
            <ToggleItem
                className="notifications-settings__main-switch"
                label={translated.pushNotifications.label}
                subLabel={translated.pushNotifications.mainSwitch}
                checked={pushDevice.data.enabled && !!pushEnabledOS}
                onToggle={onToggle}
                error={errorMessage}
                aria-label={translated.pushNotifications.label}
                data-track-id={pushTrackIDs.enable}
                data-track-linkname={pushDevice.data.enabled && !!pushEnabledOS}
                isLoading={isPending}
            >
                {!pushDevice.data.enabled && <NotificationMessage />}
            </ToggleItem>
            {pushDevice.data.enabled && featureToggles.enablePushRules && <NotificationRules />}
        </section>
    );
};

export default NotificationSwitches;
